function simulateStateAfterOrder(originalState, order) {
    const newState = JSON.parse(JSON.stringify(originalState));
    newState.units = newState.units.map((unit) => {
        if (unit.id === order.agentUnit.id) {
            unit.isFatigued = true;
            if (order.targetPosition) {
                unit.position = order.targetPosition;
            }
        }
        return unit;
    });
    return newState;
}
export default simulateStateAfterOrder;
